<template>
<div id="app">
    <keep-alive>
        <router-view />
    </keep-alive>
</div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            //没有生存周期的组件数组
            kills: [
                "myDeposit",
                "mineDeposit",
                "ComDraw",
                "accessLogQuery",
                "protocol",
                "commonDrawQ",
                "selfInfoIndex",
                "FuBaoDeposit"
            ]
        };
    },
    mounted() {
        document.body.addEventListener("focusin", () => {
        //ios软键盘弹起事件
            document.body && (document.body.scrollTop = document.body.scrollTop);
        });
        document.body.addEventListener("focusout", () => {
            //ios软键盘关闭事件
            document.body && (document.body.scrollTop = document.body.scrollTop);
        });
    }
};
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue